<template>
  <div class="lawoffotherfind">
    <sub-title text="其他方式找律师" />
    <ul>
      <li class="flex_start">
        <div><img src="../../../assets/findlawchild/otherfindicon1.png" alt="" /></div>
        <div>
          <div class="othert1">诉讼费计算器</div>
          <div class="othert2">为公众提供在线咨询服务</div>
        </div>
      </li>

      <li class="flex_start">
        <div><img src="../../../assets/findlawchild/otherfindicon2.png" alt="" /></div>
        <div>
          <div class="othert1">按专长找律师</div>
          <div class="othert2">分类明细，专业事情找专业的人</div>
        </div>
      </li>

      <li class="flex_start">
        <div><img src="../../../assets/findlawchild/otherfindicon3.png" alt="" /></div>
        <div>
          <div class="othert1">按城市找律师</div>
          <div class="othert2">无论您在哪，好律师在您身边</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";

export default {
  components: {
    subTitle,
  },
};
</script>
<style lang="scss" scoped>
.lawoffotherfind {
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  ul {
    padding: 0 8px;
    li {
      margin-top: 24px;
      cursor: pointer;
      .othert1 {
        font-size: 16px;
        color: #333333;
        line-height: 16px;
      }
      .othert2 {
        margin-top:10px ;
        font-size: 12px;
        color: #666666;
        line-height: 12px;
      }
      img {
        margin-right: 14px;
        width: 50px;
        height: 50px;
      }
    }
  }
}
</style>